import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LegalDocument } from '@shared/entities/legalDocument';
import { LegalDocumentService } from '@shared/services/api/legal-document.service';

@Component({
  selector: 'app-legal-documents',
  templateUrl: './legal-documents.component.html',
  styleUrl: './legal-documents.component.scss'
})
export class LegalDocumentsComponent implements OnInit {
  legalDocuments$!: Observable<LegalDocument[]>;

  constructor(private _legalDocumentService: LegalDocumentService) {}

  ngOnInit(): void {
    this.legalDocuments$ = this._legalDocumentService.getAll();
  }
}
